import axios from 'axios';

export const getTrabajos = async (filtros = {}) => {
  try {
    const response = await axios.get('/api/trabajos', {
      params: filtros
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener trabajos:', error);
    return [];
  }
};
